<template>
	<div class="comp">
		<div class="title">
			<div class="titleL">个人资料</div>
			<div class="titleR">
				<div class="editBtn" @click="dialogChangeInfo_state=true">修改</div>
			</div>
		</div>
		<div class="tableBox">
			<el-form label-width="150px">
				<el-form-item label="昵称:">
					<span class="msgValue">{{userDetail.nickName}}</span>
				</el-form-item>
				<el-form-item label="性别:">
					<span class="msgValue">{{userDetail.sex}}</span>
				</el-form-item>
				<el-form-item label="生日:">
					<span class="msgValue">{{$public.FTime(userDetail.birthday,"YYYY-MM-DD")}}</span>
				</el-form-item>
				<el-form-item label="我的推广码:">
					<span class="msgValue">
						<span >{{userDetail.invitationCode}}</span>
						<textarea cols="20" rows="10" style="position: fixed;z-index: -1;top:0;width:0;height: 0;" :value="userDetail.invitationCode" id="copyFun"></textarea>
						<span class="copyText" @click="copy">复制</span>
					</span>
				</el-form-item>
			</el-form>
		</div>
		<div v-if="dialogChangeInfo_state">
			<dialogChangeInfo :userDetail="userDetail" @submit="submit_dialogChangeInfo"></dialogChangeInfo>
		</div>
	</div>
</template>

<script>
	import dialogChangeInfo from "./dialog_changeInfo.vue"
	export default {
		components:{dialogChangeInfo},
		data() {
			return {
				userDetail:{},
				
				// 修改个人信息
				dialogChangeInfo_state:false,
				
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo
			}
		},
		mounted(){
			this.getUserInfo();
		},
		methods:{
			submit_dialogChangeInfo(obj){
				this.dialogChangeInfo_state=false;
				if(obj.type==='success'){
					this.getUserInfo()
				}
			},
			getUserInfo(){
				this.$http.get(process.env.VUE_APP_livingMall+'/api/User/info', {
					"id": this.userInfo.userId,
				}).then(res => {
					if(res.code===0){
						this.userDetail = res.data
						this.$store.commit('setUserInfo',res.data)
					}
				})
			},
			// 复制推广码
			copy(){
				document.getElementById('copyFun').focus()
				this.$nextTick(()=>{
					document.getElementById('copyFun').select();
					document.execCommand("Copy");
					this.$message({
						message: '复制成功',
						type: 'success'
					});
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
.comp{
	height:100%;
	.title{
		display: flex;justify-content: space-between;padding:0 0 10px;border-bottom: 1px solid #E8E8EB;
		.titleL{
			font-size: 20px;color:#303042;padding-left:10px;line-height: 48px;
		}
		.titleR{
			.editBtn{
				width: 128px;line-height: 46px;border:1px solid #5F5F72;text-align: center;cursor: pointer;border-radius: 24px;font-size: 18px;color:#303042;
			}
		}
	}
	.tableBox{
		height: calc(100% - 88px);padding-top:30px;font-size: 18px;
		.msgValue{
			font-size: 18px;color:#303042;
			.copyText{
				font-size: 20px;color:#606073;margin-left: 20px;cursor: pointer;
			}
		}
	}
}
</style>							
